var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFileZip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.17,
    height: 49.391,
    viewBox: "0 0 43.17 49.391",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-file-zip",
    "data-name": "Icon metro-file-zip",
    d: "M35.335,1.885,8.353,1.938A3.859,3.859,0,0,0,4.5,5.793V47.421a3.859,3.859,0,0,0,3.854,3.854H43.814a3.859,3.859,0,0,0,3.854-3.854L47.66,14.272C47.651,14.257,35.364,1.885,35.335,1.885Zm7.418,12.388H35.335V6.855A103.627,103.627,0,0,1,42.752,14.272Zm1.833,33.149a.781.781,0,0,1-.771.771H8.353a.781.781,0,0,1-.771-.771V5.793a.781.781,0,0,1,.771-.771h23.9V15.814a1.542,1.542,0,0,0,1.542,1.542H44.585ZM13.749,5.022h6.167V8.105H13.749Zm6.167,3.084h6.167v3.084H19.917Zm-6.167,3.084h6.167v3.084H13.749V11.189Zm6.167,3.084h6.167v3.084H19.917Zm-6.167,3.084h6.167V20.44H13.749Zm6.167,3.084h6.167v3.084H19.917Zm-6.167,3.084h6.167v3.084H13.749V23.523Zm6.167,3.084h6.167V29.69H19.917ZM13.749,42.8a2.319,2.319,0,0,0,2.313,2.313h7.709A2.319,2.319,0,0,0,26.084,42.8V35.087a2.319,2.319,0,0,0-2.313-2.313H19.917V29.69H13.749V42.8ZM23,38.941v3.084H16.833V38.941Z",
    transform: "translate(-4.499 -1.885)",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileZip);
export default __webpack_public_path__ + "static/media/icon-file-zip.32adc578834b62bb9a325c38de4e07e2.svg";
export { ForwardRef as ReactComponent };